import React from 'react';

function Map() {
	return (
			<iframe
				src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d916.9828799805447!2d77.39304364813539!3d13.09677672802688!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae25532993df5d%3A0xc9b7d42115814046!2sKANASU%20COMPUTER%20COACHING%20CENTER%20AND%20CHARITABLE%20TRUST!5e0!3m2!1sen!2sin!4v1692254218909!5m2!1sen!2sin"
				width="100%"
				height="300"
				loading="lazy"
				referrerpolicy="no-referrer-when-downgrade"
				style={{ border: 0 }}
			></iframe>
	);
}

export default Map;
